import { trackFootfallEvent, trackFootfallEventWithHrefDelay } from 'src/utils/footfall';
import EventType from 'src/constants/footfallEventTypes';
import { SyntheticEvent } from 'react';

type Section = 'home' | 'hu-logo' | 'my-hub' | 'chat' | 'alerts' | 'search' | 'more';

export function footfall(section: Section): void {
  trackFootfallEvent(EventType.CLICKED, { clickMetadata: { section }, clickType: 'member-sitebar' });
}

export function footfallExternal(e: SyntheticEvent, href: string, section: Section): void {
  e.preventDefault();
  trackFootfallEventWithHrefDelay(href, EventType.CLICKED, { clickMetadata: { section }, clickType: 'member-sitebar' });
}
